export const scrollbarStyle = {
  overflowY: 'auto',
  '&::-webkit-scrollbar': {
    width: '4px',
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#AAADB0',
    borderRadius: '20px',
  },
  '@-moz-document url-prefix()': {
    scrollbarWidth: 'thin',
    scrollbarColor: '#AAADB0 transparent',
  },
};

export const ellipsisStyle = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};
